document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.km-sticky-buy').forEach((stickyBar) => {
    const section = stickyBar.closest('.km-product-hero');
    const primaryForm = section?.querySelector('.km-product-form');

    if (!primaryForm || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      ([entry]) => stickyBar.classList.toggle('is-hidden', entry.isIntersecting),
      { threshold: 0.2 }
    );

    observer.observe(primaryForm);
  });
});
